import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'

import { modifyGroupedIdsSort, sortArrayBy } from '@domain-group/javascript-utils'

import type { CampaignQuoteTemplateSectionModel } from '@domain-group/realhub-backend-api-types'

type DefaultState = {
  sortedIds: (string | number | undefined)[],
}

type SetState = (state: Partial<DefaultState>) => void

type ModifyCampaignQuoteTemplateSectionSortParams = {
  fromIndex: number,
  payload: { [key: string]: any },
  setState: SetState,
  sortedIds: (string | number | undefined)[],
  toIndex: number,
}

const modifyCampaignQuoteTemplateSectionSort = (params: ModifyCampaignQuoteTemplateSectionSortParams) => {
  const {
    fromIndex, payload, setState, sortedIds, toIndex,
  } = params

  // @ts-expect-error TS2322
  const groupedIds = modifyGroupedIdsSort(fromIndex, toIndex, payload, { sortedIds })

  setState({ sortedIds: groupedIds.sortedIds })
}

type UseEditCampaignQuoteTemplateSectionSortOptions = {
  filteredCampaignQuoteTemplateSections: CampaignQuoteTemplateSectionModel[],
}

const defaultState: DefaultState = {
  sortedIds: [],
}

function useEditCampaignQuoteTemplateSectionSort(options: UseEditCampaignQuoteTemplateSectionSortOptions) {
  const { filteredCampaignQuoteTemplateSections = [] } = options || {}

  const [state, setState] = useSetState(defaultState)
  const { sortedIds } = state

  const sortedSections = sortArrayBy(filteredCampaignQuoteTemplateSections, 'asc', 'sort')

  // Set current sort into state
  useEffect(() => {
    const sortedSectionIds = sortedSections.map(item => item?.id)
    setState({ sortedIds: sortedSectionIds })
  }, [filteredCampaignQuoteTemplateSections.length])

  return {
    callbacks: {
      modifyCampaignQuoteTemplateSectionSort: (
        fromIndex: number,
        toIndex: number,
        payload: { [key: string]: any },
      ) => modifyCampaignQuoteTemplateSectionSort({
        fromIndex,
        payload,
        setState,
        sortedIds,
        toIndex,
      }),
    },
    sortedIds,
  }
}

export default useEditCampaignQuoteTemplateSectionSort
